<a id="userItem" href="javascript:void(0)" [ngClass]="{ selected: isSelected }" (click)="itemSelected.emit(item)">
  <div class="card-container">
    <div class="thumbnail">
      @if (isEmptyCollection) {
        <svg-icon
          class="collection-icon"
          src="/assets/icons/map-icons/shared/collection.svg"
          alt="collection"
          i18n-alt
        />
      } @else {
        <img
          class="update-brightness"
          alt="Item Image"
          loading="lazy"
          [ngSrc]="item.snapshots ?? [] | snapshotToUrl: '230x230'"
          i18n-alt
        />
      }
    </div>
    <div class="select-status">
      <mat-checkbox />
    </div>
    <div class="details">
      {{ item.name }}
    </div>

    @if (area) {
      <div class="info">
        <rdx-area-display [areaInMeters]="area" />
      </div>
    }
    @if (duration) {
      <div class="info">
        <svg-icon src="/assets/icons/time.svg" />
        <pii-duration-display [durationInSeconds]="duration" />
      </div>
    }
    @if (itemCount) {
      <div class="info">
        {{ itemCount }}
        @if (itemCount === 1) {
          <span i18n>item</span>
        } @else {
          <span i18n>items</span>
        }
      </div>
    }
    @if (length) {
      <div class="info">
        <svg-icon src="/assets/icons/distance-v2.svg" />
        <pii-distance-display [distanceInMeters]="length" />
      </div>
    }
    @if (locationStrings) {
      <div class="info location">
        <div>{{ locationStrings[0] }}</div>
        <div>{{ locationStrings[1] }}</div>
      </div>
    }
  </div>
</a>
